import { render, staticRenderFns } from "./student-list-v2.vue?vue&type=template&id=ae8c1c2a&"
import script from "./student-list-v2.vue?vue&type=script&lang=js&"
export * from "./student-list-v2.vue?vue&type=script&lang=js&"
import style0 from "./student-list-v2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports